module.exports = __webpack_public_path__ + "static/media/iconCanvas11.717e5d7f.svg";